// extracted by mini-css-extract-plugin
module.exports = {"container":"contact-module--container--_onn6","title":"contact-module--title--ZNELB","details":"contact-module--details--32Y59","mori":"contact-module--mori--DcQQP"};